import { BiReceipt } from 'react-icons/bi'
import { BsListTask } from 'react-icons/bs'
import { FiTarget } from 'react-icons/fi'

import type { ILink } from '@base/@types/components/Layout/Navigator'

const otbLinks: ILink = {
  group: 'OTB',
  icon: <FiTarget />,
  roles: ['OTB'],
  menu: [
    {
      name: 'Plano',
      path: '/otb/plano',
      icon: <BiReceipt />,
      description: 'Parâmetros para o Open To By ',
      roles: ['Administrador', 'Financeiro', 'AnalistaPlanejamento']
    },
    {
      name: 'Acompanhamento',
      path: '/otb/acompanhamento',
      icon: <BsListTask />,
      description: 'Acompanhamento do Open To By',
      roles: [
        'Administrador',
        'Financeiro',
        'Assistente',
        'AnalistaPlanejamento'
      ]
    }
  ]
}

export default otbLinks
